import { CalendarItemType } from '@akin-home/amplify';
import { CalendarItemReminder, CalendarItemReminderType } from '../types';

/** Fills in a reminder item with default values */
export function createReminderItem(input?: Partial<CalendarItemReminder>) {
  return {
    type: CalendarItemReminderType.Notification,
    secondsOffset: 0,
    ...input,
  } as CalendarItemReminder;
}

export function getDefaultReminders(type: CalendarItemType | undefined) {
  if (type === CalendarItemType.Alarm) {
    return [{ type: CalendarItemReminderType.Alarm, secondsOffset: 0 }];
  }

  return [{ type: CalendarItemReminderType.Notification, secondsOffset: 0 }];
}

export function getReminderText(reminder: CalendarItemReminder | undefined) {
  switch (reminder?.type) {
    case CalendarItemReminderType.Notification:
      return 'Notification';
    case CalendarItemReminderType.Alarm:
      return 'Alarm';
    case null:
      return 'None';
    case undefined:
      return 'None';
    default:
      return 'Custom';
  }
}
